module.exports = __webpack_public_path__ + "img/intro-illustration.7b12027f.png";